import { entity, persistence } from "simpler-state";
import {
  ColumnFiltersState,
  ColumnSort,
  PaginationState,
  RowSelectionState,
  VisibilityState
} from "@tanstack/react-table";

interface IAccountingState {
  search: string
  rowSelection: RowSelectionState
  sorting: ColumnSort[]
  columnVisibility: VisibilityState
  columnFilters: ColumnFiltersState
  pagination: PaginationState
}

export const INITIAL_ACCOUNTING_STATE: IAccountingState = {
  search: "",
  rowSelection: {},
  sorting: [],
  columnVisibility: {
    backup_parse: false,
    admin_fee: false,
    days_old: false,
    days_in_stage: false,
    dispute_expires: false,
    custom_deduction_method: false,
    backup_since_coding: false,
  },
  columnFilters: [],
  pagination: {pageIndex: 0, pageSize: 50},
}
export const AccountingState = entity(INITIAL_ACCOUNTING_STATE, [
  persistence("accounting_filters_state", {deserializeFn}),
])

function deserializeFn(blob: string): IAccountingState {
  let data = JSON.parse(blob)
  data.search = data.search ?? INITIAL_ACCOUNTING_STATE.search
  data.rowSelection = data.rowSelection ?? INITIAL_ACCOUNTING_STATE.rowSelection
  data.sorting = data.sorting ?? INITIAL_ACCOUNTING_STATE.sorting
  data.columnVisibility = {
    ...INITIAL_ACCOUNTING_STATE.columnVisibility,
    ...(data.columnVisibility ?? {}),
  }
  data.columnFilters = data.columnFilters ?? INITIAL_ACCOUNTING_STATE.columnFilters
  data.pagination = data.pagination ?? INITIAL_ACCOUNTING_STATE.pagination
  return data
}

export function handleTransactionSearch(value: string) {
  AccountingState.set(s => {
    let pagination = s.pagination
    pagination.pageIndex = 0
    return {...s, search: value, pagination}
  })
}